<template>
	<div>
		<!-- Toggle icon -->
		<a class="btn toggle-icon" id="menu-toggle" aria-label="Toggle sidebar navigation">
			<span class="sr-only">Toggle sidebar navigation</span>
			<span class="icon-open"><span class="fa fa-bars"></span></span>
			<span class="icon-close"><span class="fa fa-bars"></span></span>
		</a>

		<!-- Brand name for mobile only -->
		<div class="sidebar-brand d-block d-md-none">
			<a href="/" class="navbar-brand h4 h-100 pb-2 m-0 d-flex align-items-end justify-content-center">RDAP Research</a>
		</div>

		<div class="placeholder"></div>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.placeholder {
	height: 60px;
}
</style>
